import qs from 'qs'

const BASE_URL = 'ai-service/api/ai-objects'

export function _getAiObjectsRequest() {
  return {
    url: BASE_URL,
    method: 'get',
  }
}

const aiObjectsRequests = {
  getAiObjectsRequest: _getAiObjectsRequest,
  getAiObjectsWithStatisticsRequest: ({ pageNumber = 1, pageSize = 25, searchText }) => ({
    url: `${BASE_URL}/statistics`,
    method: 'get',
    params: {
      pageNumber,
      pageSize,
      searchQuery: searchText,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),
  addAiObjectRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  restoreAiObjectRequest: (data) => ({
    url: `${BASE_URL}/restore`,
    method: 'post',
    data,
  }),
  deleteAiObjectRequest: (aiObjectId) => ({
    url: `${BASE_URL}/${aiObjectId}`,
    method: 'delete',
  }),
  updateAiObjectRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  getAiObjectsByModelsRequest: ({ modelIds }) => ({
    url: `${BASE_URL}/by-models`,
    method: 'get',
    params: {
      modelIds,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),
  getAiModelAiObjectsRequest: ({ aiModelId }) => ({
    url: `${BASE_URL}/ai-model/${aiModelId}`,
    method: 'get',
  }),
  getAiObjectsForProjectRequest: (data) => ({
    url: `${BASE_URL}/project`,
    method: 'get',
    params: data,
  }),
  getAiObjectsByContentRequest: ({ contentId }) => ({
    url: `${BASE_URL}/content/${contentId}`,
    method: 'get',
  }),
}

export default aiObjectsRequests
